import { RefiContactHours } from './contact-hours.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';

defineRefiElement('refi-common-contact-hours', RefiContactHours);
